import { useCallback, useRef, useState } from 'react';

export const useDialog = <T extends HTMLElement>() => {
  const ref = useRef<T | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = useCallback(() => setIsOpen(true), []);
  const handleClose = useCallback(() => setIsOpen(false), []);
  const handleToggle = useCallback(() => setIsOpen(prev => !prev), []);

  return { ref, isOpen, handleOpen, handleClose, handleToggle };
};
